<template>
    <Button :disabled="disabled" :class="className" @click.native="checkout">
        {{btnText}} 
    </Button>
</template>


<script>
import Button from '../components/Theme/Button'
import {useStripe, useStore, useRouter} from '../core/hooks'
import {onMounted} from '@vue/composition-api'

export default {
    name: 'CheckoutButton',
    props: {
        btnText: String,
        className: String,
        type: String,
        location: String,
        referral: String,
        price: Object,
        disabled: Boolean
    },
    components: {
        Button
    },
    setup(props, {root}){
        const {redirectToCheckout} = useStripe()
        const {state, store} = useStore()

        const checkout = () => {
            if(props.disabled) {
                return
            }

            if(props.location) {
                root.$sendMixpanelEvent('Upgrade Now Clicked', {
                    'Location': props.location
                });

                root.$ga.event('Pricing', 'Upgrade Now Click',`
                    Location:${props.location}
                `);
            }

            if(!state.value.user) {
                return store.commit('TOGGLE_MODAL', ['sign-up', {
                    openedFrom: 'Pricing Page',
                    chosenPlanOnSignup: {
                        name: 'premium',
                        priceId: props.price.priceId
                    }
                }]);
            }

            redirectToCheckout({
                priceId: props.price.priceId,
                stripeInstance: root.$stripe,
            })
        }

        return {
            checkout
        }
    }
}
</script>